import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const CreateFaq = ({ onWebinarFaqCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    question: "",
    answer: ""
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post(`${apiUrl}/faqs`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (onWebinarFaqCreated) {
        onWebinarFaqCreated();
      }
      
      // Reset form after successful submission
      setFormData({
        slug: "",
        question: "",
        answer: ""
      });
      
      alert("FAQ created successfully!");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "An error occurred while creating the FAQ.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create FAQ</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug (URL identifier):</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., common-questions"
          />
        </div>

        <div>
          <label className="block mb-1">Question:</label>
          <input
            type="text"
            name="question"
            value={formData.question}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., How do I get started?"
          />
        </div>

        <div>
          <label className="block mb-1">Answer:</label>
          <textarea
            name="answer"
            value={formData.answer}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            rows="4"
            required
            placeholder="Enter the detailed answer..."
          ></textarea>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-2 px-4 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
        >
          {isSubmitting ? "Creating..." : "Create FAQ"}
        </button>
      </form>
    </div>
  );
};

export default CreateFaq;